// console.log(`blogFunctions is working`);

let blogSearch = document.querySelector(`.widget_search #searchsubmit`);

if (blogSearch) {
  blogSearch.classList.add(`school-style-button`);
}

const singlePostPageContent = document.querySelector(`.single_post_content`);

if (singlePostPageContent) {
  const pTagExists = document.querySelectorAll(`p`);
  pTagExists.forEach((p) => {
    const iframe = p.querySelector(`iframe`);
    if (p.contains(iframe) && iframe.offsetHeight > iframe.offsetWidth) {
      const newDiv = document.createElement(`div`);
      newDiv.classList.add(`blog-iframe`, `vertical`);
      p.insertAdjacentElement(`afterend`, newDiv);
      p.remove();
      newDiv.appendChild(iframe);
    } else if (p.contains(iframe) && iframe.offsetHeight < iframe.offsetWidth) {
      p.classList.add(`blog-iframe`, `horizontal`);
    }
  });
}
